export enum DestinationTypeEnum {
  ZIP_ONLY = 1,
  STATE_CITY = 2
}
